import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthSessionStore } from '@core/auth/auth-session.store';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(AuthSessionStore).accessToken();

  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }),
  );
};
